var GLOBAL_CONFIG_KEY = "__SWAGGER_CONFIG_REQUEST__";
var global = (function () {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    throw new Error("unable to locate global object");
}());
var defaultConfig = {
    _request: null,
    get request() {
        if (this._request) {
            return this._request;
        }
        else if (global && GLOBAL_CONFIG_KEY in global) {
            return global[GLOBAL_CONFIG_KEY];
        }
        else {
            return function () { return Promise.reject('The [swagger-api#request] option is required'); };
        }
    },
    set request(value) {
        this._request = value;
        if (global) {
            global[GLOBAL_CONFIG_KEY] = value;
        }
    }
};
export default defaultConfig;
